/**
 * roundIndex moved. Did the learner reach a different LEGO, or did earlier
 * rounds merely get inserted in front of the one they are on (job #812:
 * addRounds shifts roundIndex when the previous round lands after init)?
 *
 * A real change starts at cycle 0 and counts as practice. A shift keeps the
 * same LEGO and cycle: the bookmark must keep its live cycle and must not be
 * stamped as practised.
 */
export type RoundIndexChange = 'new-round' | 'index-shift'

export function classifyRoundIndexChange(
  previousLegoId: string | null | undefined,
  currentLegoId: string | null | undefined,
): RoundIndexChange {
  return previousLegoId && currentLegoId && previousLegoId === currentLegoId ? 'index-shift' : 'new-round'
}
